<app-stepper-form
  header="Notification by Officeholder of Resignation or Retirement"
  subheader="Form 370"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [form]="stepperForm"
  [isLoading]="isLoading"
  [showSteps]="false"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="370"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    ></app-stepper-form-description>

    <section
      class="step-section"
      [formGroupName]="StepsEnum.ResignationDetails"
      [hidden]="currentStep !== StepsEnum.ResignationDetails"
    >
      <h1 class="h1-heading">Resignation Details</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Resignation"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        ></app-date-picker>
      </div>

      <div class="form-group">
        <app-date-picker
          label="Date the letter handed in"
          formControlName="resignationLetterGiven"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        ></app-date-picker>
      </div>

      <div class="form-group">
        <app-yes-no-control
          label="Select Existing Officer?"
          formControlName="isFormerOfficerResignation"
          [reversedValues]="true"
        ></app-yes-no-control>
      </div>

      <div class="form-group" [hidden]="form.controls.isFormerOfficerResignation.value !== false">
        <app-select
          label="Resigning Officer"
          formControlName="appointedOfficerId"
          [options]="officersSelectOptions"
          [valuePrimitive]="true"
        ></app-select>
      </div>

      <div [hidden]="form.controls.isFormerOfficerResignation.value !== true">
        <div class="form-group" [formGroup]="form">
          <app-individual-data-form-group [formGroup]="form.controls.formerOfficeholder" />
        </div>

        <div class="form-group">
          <app-select
            label="Position"
            formControlName="type"
            [options]="positionTypesOptions"
            [valuePrimitive]="true"
          ></app-select>
        </div>
      </div>

      <div class="form-group" [hidden]="form.controls.isFormerOfficerResignation.value === null">
        <app-textarea
          label="Resignation Letter"
          formControlName="resignationLetterText"
        ></app-textarea>
      </div>
    </section>
  </div>
</app-stepper-form>
